import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";

import { debounceTime, exhaustMap, filter, map, scan, startWith, switchMap, tap } from 'rxjs/operators';
import { Observable ,Subject} from 'rxjs';
import { of } from 'rxjs/internal/observable/of';


@Component({
    selector: 'edms-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.css']
})
export class EdmsAutoCompleteComponent implements OnInit, OnDestroy {
    @ViewChild('searchText') searchText!: ElementRef<HTMLInputElement>;;
    @Input() data: any[] = [];
    @Input() textField: string = '';
    @Input() form!: FormGroup;
    @Input() controlName: string = '';
    @Input() label: string = '';
    @Input() error: string = '';
    @Input() value: any;
    @Input() isValidateOptionRequired: boolean = false;
    @Output() optionSelected = new EventEmitter<any>();
    isSelectedEventTriggered: boolean = false;
    isPanelOpened: boolean = false;
    inputValue: string = '';
    filteredOptions: Observable<any[]> | undefined;
    private _nextPage$ = new Subject();
    private _destroyed$ = new Subject();
    filter$: Observable<any> | undefined;
    ngOnInit() {
        this.listenChange();
        if (this.value)
            this.form.get(this.controlName)?.setValue(this.value);
        if (this.isValidateOptionRequired)
            this.form.get(this.controlName)?.setValidators(this.validateOptionSelection.bind(this));
    }

    hasInputData(): boolean {
        if (this.data)
            return true;
        else

            return false;
        //&& this.data.length > 0;
    }

    listenChange(): void {
        let searchText: string = '';
        if (this.value)
            searchText = this.value[this.textField];
        // Note: listen for search text changes
        let _x: any = this.form.get(this.controlName)
        if (_x)
            this.filter$ = _x.valueChanges.pipe(
                startWith(searchText),
                debounceTime(200),
                // Note: If the option value is bound to object, after selecting the option
                // Note: the value will change from string to {}. We want to perform search 
                // Note: only when the type is string (no match)
                map((value: any) => typeof value === 'string' ? value : value[this.textField]),
                filter(q => typeof q === "string"));
        this.filterOptions();
    }

    clearSearchText(): void {
        this.form.get(this.controlName)?.setValue('');
        this.resetControl('');
        this.isSelectedEventTriggered = false;
        if (!this.isPanelOpened)
            //Emit selected option to caller component
            this.optionSelected.emit(-1);
    }

    private filterOptions(): void {
        // Note: There are 2 stream here: the search text changes stream and the nextPage$ (raised by directive at 80% scroll)
        // Note: On every search text change, we issue a backend request starting the first page
        // Note: While the backend is processing our request we ignore any other NextPage emitts (exhaustMap).
        // Note: If in this time the search text changes, we don't need those results anymore (switchMap)
        this.filteredOptions = this.filter$?.pipe(
            switchMap((filter: any) => {
                //Note: Reset the page with every new seach text
                let currentPage = 1;
                return this._nextPage$.pipe(
                    startWith(currentPage),
                    //Note: Until the backend responds, ignore NextPage requests.
                    exhaustMap(_ => this.getOptionsFake(filter, currentPage)),
                    tap(() => currentPage++),
                    //Note: This is a custom operator because we also need the last emitted value.
                    //Note: Stop if there are no more pages, or no results at all for the current search text.
                    //takeWhileInclusive(p => p.length > 0),
                    scan((allOptions, newOptions: any) => allOptions.concat(newOptions), []),
                );
            })
            );
    }

    // Fake backend api
    private getOptionsFake(startsWith: string, page: number):any {
        const take = 10;
        const skip = page > 0 ? (page - 1) * take : 0;
        const filtered = this.data
            .filter(option => option[this.textField].toLowerCase().indexOf(startsWith.toLowerCase()) !== -1)
        return of(filtered.slice(skip, skip + take));
    }



    public displayProperty(obj: any) {
        return obj && obj[this.textField] ? obj[this.textField] : '';
    }

    validateOptionSelection(abstractControl: AbstractControl): ValidationErrors | null | void {
        if (abstractControl.touched || abstractControl.dirty) {
            let selectedValue: any = abstractControl.value;
            if (!this.data.includes(selectedValue)) {
                return { IsError: true };
            } else {
                return null;
            }
        }
    }


    selected(event: MatAutocompleteSelectedEvent): void {
        this.resetControl(event.option.value[this.textField]);
        //Emit selected option to caller component
        this.optionSelected.emit(event.option.value);
        this.isSelectedEventTriggered = true;
    }

    closed(event: any): void {
        if (!this.isSelectedEventTriggered)
            //Emit selected option to caller component
            this.optionSelected.emit(-1);
        else
            //reset the selected event triggered as false
            this.isSelectedEventTriggered = false;
        this.isPanelOpened = false;
    }

    opened(event: any): void {
        this.isPanelOpened = true;
    }

    resetControl(value: string) {
        //Show the autocomplete panel automatically after clear the text
        this.searchText.nativeElement.value = value;
        this.searchText.nativeElement.blur();
    }

    onScroll() {
        //Note: This is called multiple times after the scroll has reached the 80% threshold position.
        this._nextPage$.next(true);
    }

    public ngOnDestroy(): void {
        this._destroyed$.next(null);
        this._destroyed$.complete();
    }

    hasRequiredError(): boolean | undefined {
        return this.form.get(this.controlName)?.hasError('required');
    }

    hasFormControlError(): boolean | void {
        if (this.form.get(this.controlName)?.errors && !this.form.get(this.controlName)?.hasError('required')) {
            return this.form.get(this.controlName)?.errors?.['IsError']
        }
    }
}